import { render, staticRenderFns } from "./Vipbodyguards_dialog.vue?vue&type=template&id=589267a7&scoped=true&"
import script from "./Vipbodyguards_dialog.vue?vue&type=script&lang=js&"
export * from "./Vipbodyguards_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Vipbodyguards_dialog.vue?vue&type=style&index=0&id=589267a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589267a7",
  null
  
)

export default component.exports